import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

export default function activityFieldsReducer(state = initialState.currentOffer.clientActivityFieldsData, action) {
  switch (action.type) {
    case types.LOAD_ACTIVITY_FIELDS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, isLoaded: false };
      return result;
    }

    case types.LOAD_ACTIVITY_FIELDS_SUCCEEDED: {
      const { partnerActivityFields } = action.payload;
      const partnerId = partnerActivityFields.partnerId;
      let result = { ...state };
      result[partnerId] = { ...state[partnerId], loading: false, isLoaded: true };
      return result;
    }

    case types.LOAD_ACTIVITY_FIELDS_FAILED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, isLoaded: false };
      return result;
    }

    case types.UPDATE_ACTIVITY_FIELDS_SUCCEEDED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, isLoaded: true };
      return result;
    }

    case eventTypes.ACTIVITY_FIELDS_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, isLoaded: false };
      return result;
    }

    default:
      return state;
  }
}
